import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import EditSubFamily from "../../ui/EditSubFamily";
import ProductService from "../../services/ProductService";
import PagedCardTable from "../../ui/PagedCardTable";

const ProductsSubFamily = () => {
  const navigate = useNavigate();
  const [reloadKey, setReloadKey] = useState(0);
  const [alert, setAlert] = useState(null);
  const [oldSubFamilyData, setOldSubFamilyData] = useState();
  const [onEditSubFamily, setOnEditSubFamily] = useState(false);

  const fetchAvailable = useCallback(
    (params) =>
      ProductService.getReferencePage("SubFamilies", { ...params, isDeleted: 0 }),
    []
  );
  const fetchArchived = useCallback(
    (params) =>
      ProductService.getReferencePage("SubFamilies", { ...params, isDeleted: 1 }),
    []
  );

  const onArchiveHandler = (id, archiveOrRestored) => {
    ProductService.archiveOrRestoreReference("SubFamily", id, archiveOrRestored)
      .then(() => {
        setAlert({
          severity: "success",
          text:
            archiveOrRestored === 1
              ? "Élément archivé avec succès"
              : "Élément restauré avec succès",
        });
        setReloadKey((key) => key + 1);
      })
      .catch(() =>
        setAlert({ severity: "error", text: "Erreur : opération impossible" })
      );
  };

  const onEditSubFamilyHandler = (row) => {
    setOldSubFamilyData({
      idSubFamily: row.id,
      name: row.name,
      description: row.description,
      productFamilyId: row.productFamilyId,
      productFamilyName: row.productFamilyName,
    });
    setOnEditSubFamily(true);
  };
  const onViewProductsHandler = (subFamilyId) => {
    sessionStorage.setItem("typePage", "subFamily");
    sessionStorage.setItem("idSubFamily", subFamilyId);
    navigate(`/getListProductsInfo`);
  };

  const availableColumns = [
    {
      label: "Référence",
      width: "12%",
      render: (row) => row.sku || "-",
    },
    {
      label: "Libellé",
      render: (row) => row.name,
    },
    {
      label: "Famille",
      render: (row) => row.productFamilyName,
    },
    {
      label: "Description",
      render: (row) => row.description || "-",
    },
    {
      label: "DC",
      width: "12%",
      render: (row) => row.creationDate,
    },

    {
      label: "Modifier",
      width: "10%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn bg-gray btn-sm"
          title="Modifier"
          onClick={() => onEditSubFamilyHandler(row)}
        >
          <i className="fas fa-pencil-alt"></i>
        </button>
      ),
    },
    {
      label: "Voir Plus",
      width: "10%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn bg-black btn-sm"
          title="Voir les produits"
          onClick={() => onViewProductsHandler(row.id)}
        >
          <i className="fas fa-shopping-cart"></i>
        </button>
      ),
    },
    {
      label: "Archiver",
      width: "10%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn btn-danger btn-sm"
          title="Archiver"
          onClick={() => onArchiveHandler(row.id, 1)}
        >
          <i className="fas fa-trash"></i>
        </button>
      ),
    },
  ];

  const archivedColumns = [
    {
      label: "Référence",
      width: "15%",
      render: (row) => row.sku || "-",
    },
    {
      label: "Libellé",
      render: (row) => row.name,
    },
    {
      label: "Famille",
      render: (row) => row.productFamilyName,
    },
    {
      label: "DC",
      width: "15%",
      render: (row) => row.creationDate,
    },

    {
      label: "Restaurer",
      width: "12%",
      align: "center",
      render: (row) => (
        <button
          style={{ width: 40 }}
          className="btn bg-gray-dark btn-sm"
          title="Restaurer"
          onClick={() => onArchiveHandler(row.id, 0)}
        >
          <RestoreFromTrashRoundedIcon />
        </button>
      ),
    },
  ];

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-layer-group mr-2"></i>Sous-familles
              </h4>
              <small className="text-muted">Gérez les sous-familles de produits</small>
            </div>
            <div className="mt-2 mt-sm-0">
              <button
                className="btn btn-outline-dark mr-2"
                onClick={() => navigate(`/uploadExcel?type=subFamilies`)}
              >
                <i className="fas fa-file-excel mr-1"></i>
                Importer un fichier Excel
              </button>
              <button className="btn btn-dark" onClick={() => navigate(`/addSubFamily`)}>
                <i className="fas fa-plus mr-1"></i>
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </section>
      <div className="content">
        <div className="container-fluid">
          <PagedCardTable
            title="Les sous-familles disponibles"
            icon="fas fa-layer-group"
            fetchPage={fetchAvailable}
            columns={availableColumns}
            reloadKey={reloadKey}
          />
          <PagedCardTable
            title="Les sous-familles non disponibles"
            icon="fas fa-archive"
            badgeClass="badge-secondary"
            fetchPage={fetchArchived}
            columns={archivedColumns}
            reloadKey={reloadKey}
            emptyText="Aucun élément archivé"
          />
        </div>
      </div>
      {alert && (
        <Snackbar
          open
          autoHideDuration={2500}
          onClose={() => setAlert(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={() => setAlert(null)} severity={alert.severity}>
            {alert.text}
          </Alert>
        </Snackbar>
      )}
      {onEditSubFamily && (
        <EditSubFamily
          setOnEditSubFamily={setOnEditSubFamily}
          oldSubFamilyData={oldSubFamilyData}
        />
      )}
    </div>
  );
};
export default ProductsSubFamily;
